// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterValueSelection.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
//</copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from "react";
import { observer } from "mobx-react";
import m from "mobx";
import ReportDesignerFieldsStore from "logic/Izenda.ReportDesignerFieldsStore";
import DashboardFilterStore from "logic/Izenda.DashboardFilterStore";
import ReportDesignerStore from "logic/Izenda.ReportDesignerStore";
import FilterSubscription from "./Izenda.FilterSubscription";
import localizer from "share/localization/Izenda.Localizer";
import { filter, get, find, forEach } from "lodash/fp";

@observer
class FilterValueSelection extends Component {
  static propTypes = {
    data: PropTypes.object
  };

  static displayName = "FilterValueSelection";

  constructor(props) {
    super(props);
    let { dashboardDetail, data, reportState } = props;
    this.store = null;
    let subscriptionFilterValues = null;

    if (dashboardDetail) {
      this.store = new DashboardFilterStore(dashboardDetail);
      subscriptionFilterValues = data.subscriptionCommonFilterFields;
      this.store.getFilterData(null, subscriptionFilterValues).then(() => {
        const isDashboard = true;
        const subscriptionData = this.props.data;
        const subscriptionCommonFilterFields = data.subscriptionCommonFilterFields;
        const configFieldList = get('store.model.reportFilter.configFieldList', this);
        const commonfilters = get('store.filters', this);
        if(subscriptionCommonFilterFields.length == 0) {
          this.initDefaultFilters(subscriptionData, configFieldList, isDashboard, commonfilters);
        }

      });
    } else {
      let masterStore = new ReportDesignerStore();
      this.store = new ReportDesignerFieldsStore(
        masterStore,
        true,
        reportState
      );
      this.store.reportStore.model.reportId = data.reportId;
      subscriptionFilterValues = data.subscriptionFilterFields;
      this.store.loadReportFilter().then(result => {
        this.store.getFilterData(null, subscriptionFilterValues).then(() => {
          const isDashboard = false;
          const {configFieldList, filterFields} = this.store.model.reportFilter;          
          const subscriptionData = this.props.data;
          // set default value for subscription filter based on report filter value
          if(data.subscriptionFilterFields.length == 0) {
            this.initDefaultFilters(subscriptionData, configFieldList, isDashboard, result);
          }
        });
      });
    }
  }

  /**
   * init default filter value for report and dashboard subscription
   */
  initDefaultFilters(subscriptionData, configFieldList, isDashboard, reportFilters) {
    forEach(item => {
      const filterFieldId = item.fieldDetails.id;
      const reportFilter = isDashboard 
                          ? find({ 'id': filterFieldId}, reportFilters) 
                          : find({ 'sourceFieldName': item.sourceFieldName}, reportFilters);
      const {value, operatorId, operatorSetting} = reportFilter;
      item.updateFilterValue(subscriptionData, filterFieldId, isDashboard, value, operatorId, operatorSetting);
    }, configFieldList);
  }

  /**
   * Show filter
   * @returns {Boolean}
   */
  showFilter = () => {
    return (
      this.store.model.reportFilter.configFieldList.length > 0 &&
      filter(
        config => config.filterInfo.operator.name !== "...",
        this.store.model.reportFilter.configFieldList
      ).length > 0
    );
  };

  /**
   * Render Component
   * @returns {Object} component
   */
  render() {
    return this.showFilter()
      ? <div>
          <div className="text-center izenda-text-bold">
            {localizer.getText("SUBSCRIPTION_LABEL_FILTER_VALUE_SELECTION")}
          </div>
          <FilterSubscription
            {...this.props}
            filterStore={this.store}
            filters={this.store.model.reportFilter}
            isLazyLoading
          />
        </div>
      : null;
  }
}

export default FilterValueSelection;



// WEBPACK FOOTER //
// ./ui/modules/Subscription/Izenda.FilterValueSelection.js